import { ManagerAuthorization } from '@common/enums';

export enum ManagerAuthorizationGroups {
    deviceRegistration = 'Apparaat regristratie',
    exports = 'Exports',
    finance = 'Financieel',
    groups = 'Groepen',
    imports = 'Imports',
    logging = 'Logging',
    managementOldAccounts = 'Oude account beheer',
    managerAccounts = 'Beheerder accounts',
    organizationAndPractitioner = 'Organisatie & zorgverlener',
    other = 'Overig',
    patients = 'Patiënten',
    processesAndCareActivities = 'Processen/Zorgactiviteiten',
    services = 'Diensten',
    systemMaintenance = 'Systeembeheer',
    uzoviAndInsurance = 'UZOVIs en verzekeraars',
}

export const managerAuthorizationDescriptionTranslation: {
    [key in ManagerAuthorization]: {
        description: string;
        group: ManagerAuthorizationGroups | ManagerAuthorizationGroups[];
    };
} = {
    [ManagerAuthorization.organizationRead]: {
        description: 'Inzage organisaties',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.organizationAddEdit]: {
        description: 'Bewerken/Toevoegen organisaties',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.practitionerRead]: {
        description: 'Inzage zorgverlener',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.practitionerAddEdit]: {
        description: 'Bewerken/Toevoegen zorgverlener',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.employmentSettingsRead]: {
        description: 'Inzage betrekking',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.employmentSettingsEdit]: {
        description: 'Bewerken betrekking',
        group: ManagerAuthorizationGroups.organizationAndPractitioner,
    },
    [ManagerAuthorization.groupRead]: {
        description: 'Inzage groepen',
        group: ManagerAuthorizationGroups.groups,
    },
    [ManagerAuthorization.groupAddEdit]: {
        description: 'Bewerken/Toevoegen groepen',
        group: ManagerAuthorizationGroups.groups,
    },
    [ManagerAuthorization.patientReadBasic]: {
        description: 'Inzage basisgegevens patiënt',
        group: ManagerAuthorizationGroups.patients,
    },
    [ManagerAuthorization.patientReadContactData]: {
        description: 'Inzage contactgegevens patiënt',
        group: ManagerAuthorizationGroups.patients,
    },
    [ManagerAuthorization.patientInsurance]: {
        description: 'Inzage verzekeringsgegevens patiënt',
        group: ManagerAuthorizationGroups.patients,
    },
    [ManagerAuthorization.patientEdit]: {
        description: 'Bewerken patiëntgegevens',
        group: ManagerAuthorizationGroups.patients,
    },
    [ManagerAuthorization.patientProcesses]: {
        description: 'Inzage medische gegevens patiënt',
        group: ManagerAuthorizationGroups.patients,
    },
    [ManagerAuthorization.adminProcessRead]: {
        description: 'Inzage processen',
        group: ManagerAuthorizationGroups.processesAndCareActivities,
    },
    [ManagerAuthorization.adminProcessEdit]: {
        description: 'Acties op processen',
        group: ManagerAuthorizationGroups.processesAndCareActivities,
    },
    [ManagerAuthorization.organizationFinanceData]: {
        description: 'Organisatie financiële data',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.employmentFinanceData]: {
        description: 'Zorgverlener financiële data',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.reportFinancialComplete]: {
        description: 'Financieel rapport (totaal)',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.reportPayouts]: {
        description: 'Rapport uitbetalingen',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.reportFunding]: {
        description: 'Rapport bekostiging',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.financePayoutsEdit]: {
        description: 'Uitbetalingen scherm: opnieuw verwerken uitbetalingen, onbetaald, betaald',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.financePayoutsRead]: {
        description: 'Uitbetalingen scherm: rapport downloaden, inzage uitbetalingen',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.financeFunding]: {
        description: 'Bekostiging',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.groupReadFinanceData]: {
        description: 'Inzage groep financiële data',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.groupEditFinanceData]: {
        description: 'Bewerken financiële data groep',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.uzovisRead]: {
        description: "Inzage UZOVI's",
        group: ManagerAuthorizationGroups.uzoviAndInsurance,
    },
    [ManagerAuthorization.uzovisAddEdit]: {
        description: "Bewerken/Toevoegen UZOVI's",
        group: ManagerAuthorizationGroups.uzoviAndInsurance,
    },
    [ManagerAuthorization.insurersRead]: {
        description: 'Inzage verzekeraars',
        group: ManagerAuthorizationGroups.uzoviAndInsurance,
    },
    [ManagerAuthorization.insurersAddEdit]: {
        description: 'Beheer verzekeraars instellingen',
        group: ManagerAuthorizationGroups.uzoviAndInsurance,
    },
    [ManagerAuthorization.adminsRead]: {
        description: 'Inzage ksyos medewerkers',
        group: ManagerAuthorizationGroups.managerAccounts,
    },
    [ManagerAuthorization.adminsAddEdit]: {
        description: 'Bewerken ksyos medewerkers',
        group: ManagerAuthorizationGroups.managerAccounts,
    },
    [ManagerAuthorization.devicesRead]: {
        description: 'Devices & accessoires inzage',
        group: ManagerAuthorizationGroups.deviceRegistration,
    },
    [ManagerAuthorization.devicesAddEdit]: {
        description: 'Devices & accessoires toevoegen',
        group: ManagerAuthorizationGroups.deviceRegistration,
    },
    [ManagerAuthorization.deviceAndAccessoryTypes]: {
        description: 'Device types en accessoire types',
        group: ManagerAuthorizationGroups.deviceRegistration,
    },
    [ManagerAuthorization.servicesRead]: {
        description: 'Inzage dienst instellingen',
        group: ManagerAuthorizationGroups.services,
    },
    [ManagerAuthorization.serviceAddEdit]: {
        description: 'Bewerken dienst instellingen',
        group: ManagerAuthorizationGroups.services,
    },
    [ManagerAuthorization.graderPools]: {
        description: 'Beheer beoordelaars pools',
        group: ManagerAuthorizationGroups.services,
    },
    [ManagerAuthorization.serviceDeclarationRules]: {
        description: 'Beheer declaratieregels',
        group: ManagerAuthorizationGroups.services,
    },
    [ManagerAuthorization.exportPayoutRecords]: {
        description: 'Export uitbetalingen',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportDeclarationRecords]: {
        description: 'Export declaraties',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportInvoiceRecords]: {
        description: 'Export facturaties',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportUbd]: {
        description: 'Export UBD',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportPatientQuestionnaires]: {
        description: 'Export vragenlijsten',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportDesktopTest]: {
        description: 'Export desktop test resultaten',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.exportFundusFiles]: {
        description: 'Export fundus bestanden',
        group: ManagerAuthorizationGroups.exports,
    },
    [ManagerAuthorization.importDhd]: {
        description: 'Upload DHD ',
        group: ManagerAuthorizationGroups.imports,
    },
    [ManagerAuthorization.importNoShows]: {
        description: 'Upload no shows',
        group: ManagerAuthorizationGroups.imports,
    },
    [ManagerAuthorization.importExactRelationData]: {
        description: 'Importeren exact relaties',
        group: ManagerAuthorizationGroups.imports,
    },
    [ManagerAuthorization.importBankAccounts]: {
        description: 'Importeren bankrekeningen',
        group: ManagerAuthorizationGroups.imports,
    },
    [ManagerAuthorization.importHardwareTokens]: {
        description: 'Importeren hardware tokens',
        group: ManagerAuthorizationGroups.imports,
    },
    [ManagerAuthorization.patientAccessLog]: {
        description: 'Patient toegangslog',
        group: ManagerAuthorizationGroups.logging,
    },
    [ManagerAuthorization.desktopProcessesLog]: {
        description: 'Log desktop processen',
        group: ManagerAuthorizationGroups.logging,
    },
    [ManagerAuthorization.dermaAppRegistrationLogs]: {
        description: 'Log derma app registraties',
        group: ManagerAuthorizationGroups.logging,
    },
    [ManagerAuthorization.fundingLogRead]: {
        description: 'Bekostigingslog',
        group: ManagerAuthorizationGroups.logging,
    },
    [ManagerAuthorization.managerAuthorizations]: {
        description: 'Beheer autorisaties en rollen',
        group: [ManagerAuthorizationGroups.systemMaintenance, ManagerAuthorizationGroups.other],
    },
    [ManagerAuthorization.jobs]: {
        description: 'Jobs',
        group: ManagerAuthorizationGroups.systemMaintenance,
    },
    [ManagerAuthorization.thirdPartyMessages]: {
        description: 'Uitgaande berichten',
        group: ManagerAuthorizationGroups.systemMaintenance,
    },
    [ManagerAuthorization.thirdPartyIncomingMessages]: {
        description: 'Binnenkomende berichten',
        group: ManagerAuthorizationGroups.systemMaintenance,
    },
    [ManagerAuthorization.serviceRightsCareproviders]: {
        description: 'Beheer rechten zorgverleners (oude beheerschermen)',
        group: ManagerAuthorizationGroups.managementOldAccounts,
    },
    [ManagerAuthorization.serviceRightsOrganizations]: {
        description: 'Beheer rechten organisaties (oude beheerschermen)',
        group: ManagerAuthorizationGroups.managementOldAccounts,
    },
    [ManagerAuthorization.serviceRightsGroups]: {
        description: 'Beheer rechten groepen (oude beheerschermen)',
        group: ManagerAuthorizationGroups.managementOldAccounts,
    },
    [ManagerAuthorization.employmentsOld]: {
        description: 'Beheer betrekkingen (oude beheerschermen)',
        group: ManagerAuthorizationGroups.managementOldAccounts,
    },
    [ManagerAuthorization.patientDataRequests]: {
        description: 'Patient dossier verzoeken',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.embloomQuestionnaires]: {
        description: 'Beheer Embloom vragenlijsten',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.failedProcessWorkflowStepRerun]: {
        description: 'Rerun gefaalde workflow steps',
        group: ManagerAuthorizationGroups.systemMaintenance,
    },
    [ManagerAuthorization.organizationRelationNumberEdit]: {
        description: 'Organisatie relatienummer beheer',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.employmentRelationNumberEdit]: {
        description: 'Betrekking relatienummer beheer',
        group: ManagerAuthorizationGroups.finance,
    },
    [ManagerAuthorization.contractFundingDataAddEdit]: {
        description: 'Bewerken/Toevoegen contractbekostiging',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.accountRequestReviewAddEdit]: {
        description: 'Wijzigen goedkeurder, zelf afwijzen/goedkeuren accountaanvraag',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.featureFlag]: {
        description: 'Feature flags',
        group: ManagerAuthorizationGroups.systemMaintenance,
    },
    [ManagerAuthorization.fundusScreeningManualImport]: {
        description: 'Upload Fundus excel',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.chatbotSso]: {
        description: 'Can make use of the AI chatbot SSO button',
        group: ManagerAuthorizationGroups.other,
    },
    [ManagerAuthorization.updateProcessWorkflowStepsAndActivities]: {
        description: 'Updaten workflowsteps en activiteiten',
        group: ManagerAuthorizationGroups.processesAndCareActivities,
    },
};
